import React, { useState } from 'react';
import { Stepper, Step, StepLabel, Box, Typography, Button, Paper } from '@mui/material';
import Paso1TipoPersona from './Paso1TipoPersona';
import Paso2DatosFactura from './Paso2DatosFactura';
import Paso3TipoTecho from './Paso3TipoTecho';
import Paso4Ubicacion from './Paso4Ubicacion';
import ResumenPrecotizacion from './ResumenPrecotizacion';
import Paso2BResultadosParciales from './Paso2BResultadosParciales';
import PasoDatos from './PasoDatos';

const steps = [
    'Tipo de Persona',
    'Datos de Factura',
    'Resultados Preliminares',
    'Tipo de Techo',
    'Ubicación',
    'Datos Personales',
    'Resumen'
];

const PrecotizacionWizard = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [precotizacionData, setPrecotizacionData] = useState({
        tipoPersona: null,
        valorFactura: '',
        estrato: null,
        departamento: null,
        municipio: null,
        tipoTecho: null,
        ubicacion: null,
        nombre: '',
        celular: '',
        correo: ''
    });

    const handleNext = (stepData) => {
        setPrecotizacionData(prev => ({ ...prev, ...stepData }));
        setActiveStep(prev => prev + 1);
    };

    const handleBack = () => {
        setActiveStep(prev => prev - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
        setPrecotizacionData({
            tipoPersona: null,
            valorFactura: '',
            estrato: null,
            departamento: null,
            municipio: null,
            tipoTecho: null,
            ubicacion: null,
            nombre: '',
            celular: '',
            correo: ''
        });
    };

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return <Paso1TipoPersona onNext={handleNext} initialData={precotizacionData} />;
            case 1:
                return <Paso2DatosFactura onNext={handleNext} onBack={handleBack} initialData={precotizacionData} />;
            case 2:
                return (
                    <Paso2BResultadosParciales
                        onNext={handleNext}
                        onBack={handleBack}
                        data={precotizacionData}
                        onWhatsAppClick={handleWhatsAppClick}
                    />
                );
            case 3:
                return <Paso3TipoTecho onNext={handleNext} onBack={handleBack} initialData={precotizacionData} />;
            case 4:
                return <Paso4Ubicacion onNext={handleNext} onBack={handleBack} initialData={precotizacionData} />;
            case 5:
                return (
                    <PasoDatos
                        onNext={handleNext}
                        onBack={handleBack}
                        initialData={precotizacionData}
                        onChange={(updatedData) => setPrecotizacionData(prev => ({ ...prev, ...updatedData }))}
                    />
                );
            case 6:
                return <ResumenPrecotizacion
                    data={precotizacionData}
                    onReset={handleReset}
                    onBack={handleBack}
                    setActiveStep={setActiveStep}
                />;
            default:
                return 'Paso desconocido';
        }
    };

    const handleWhatsAppClick = () => {
        const message = `Hola, tengo dudas sobre mi precotización. 
      Factura: ${precotizacionData.valorFactura}
      Ciudad: ${precotizacionData.municipio?.Nombre || 'No especificada'}`;

        const encodedMessage = encodeURIComponent(message);
        window.open(`https://wa.me/573154340012?text=${encodedMessage}`, '_blank');
    };

    return (
        <Box sx={{ maxWidth: '800px', margin: '0 auto', padding: 3 }}>
            <Paper elevation={3} sx={{ padding: 3 }}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Box sx={{ marginTop: 4 }}>
                    {getStepContent(activeStep)}
                </Box>
            </Paper>
        </Box>
    );
};

export default PrecotizacionWizard;